import { SchoolIcon, TrophyIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Collection {
  icon: LucideIcon
  title: string
  subtitle: string
  volumes: string[]
  summary: string
}

export const collections: Collection[] = [
  {
    icon: SchoolIcon,
    title: 'Elementary Collection',
    subtitle: '5 progressive volumes',
    volumes: [
      'Volume 1 — Move & Explore',
      'Volume 2 — Build & Control',
      'Volume 3 — Combine & Cooperate',
      'Volume 4 — Apply & Decide',
      'Volume 5 — Adapt & Perform',
    ],
    summary:
      'Build movement confidence, coordination, cooperation, decision-making, and personal progress through age-appropriate activities.',
  },
  {
    icon: TrophyIcon,
    title: 'Secondary Collection',
    subtitle: '5 progressive volumes',
    volumes: [
      'Volume 1 — Refine & Transition',
      'Volume 2 — Solve & Collaborate',
      'Volume 3 — Apply & Influence',
      'Volume 4 — Plan & Lead',
      'Volume 5 — Sustain & Empower',
    ],
    summary:
      'Develop refined performance, tactical understanding, collaboration, self-regulation, leadership, and sustainable participation.',
  },
]
